// Blur handler - no auto-save, items are saved when user clicks "Save Changes"
export default (itemId, field) => (dispatch, getState) => {
  // No auto-save on blur - items remain in Redux state until explicitly saved
};
